import { Button, Checkbox, Form } from 'antd';
import styled from 'styled-components';

export const OTPMethodForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SendButton = styled(Button)`
  &.ant-btn.ant-btn-primary {
    height: auto;
    padding: 12.5px;
    border-radius: 4px;

    font-weight: bold;
    font-size: 14px;
    line-height: 19px;

    :disabled {
      color: #ffffff;
    }
  }
`;
